import { ChangeDetectionStrategy, Component, input, InputSignal, OnDestroy, OnInit, output, OutputEmitterRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Observable, of, take } from 'rxjs';
import { FormConfig } from '@/app/components/forms/form.objects';
import { FormPlycaComponent } from '@/app/components/forms/formPlyca.component';
import { BaseComponent } from '@/app/components/common/baseComponent/base.component';
import { FilterGenericData, FilterGenericConfig } from './_config/filter-generic.model';
import { PlycaUiScrollPanelComponent } from '../../panels/scroll-panel/scroll-panel.component';

@Component({
  selector: 'plyca-ui-filter-generic',
  templateUrl: './filter-generic.component.html',
  styleUrl: './filter-generic.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormPlycaComponent, PlycaUiScrollPanelComponent]
})
export class PlycaUiFilterGenericComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('formPlycaRef') formPlycaRef: FormPlycaComponent;

  public formConfig: FormConfig;
  public config: InputSignal<FilterGenericConfig> = input.required<FilterGenericConfig>();
  public valuesFormChange: OutputEmitterRef<FilterGenericData> = output<FilterGenericData>();

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.dtoToModel();
  }

  public dtoToModel(): void {
    this.subscribe(this.setJson().pipe(take(1)), (form: FormConfig) => {
      if (form) {
        const adaptedConfig = this.config()?.formConfigAdapted ?? {};
        this.formConfig = { ...form, ...adaptedConfig };
        this.valuesFormChange.emit({ isLoaded: true, formPlycaRef: this.formPlycaRef, formConfig: this.formConfig });
      }
    });
  }

  private setJson(): Observable<FormConfig> {
    if (!this.config().jsonFile) {
      return;
    }
    return of(new FormConfig(undefined, this.config().jsonFile, this.config().model));
  }

  public onValueChange(event: FilterGenericData): void {
    this.valuesFormChange.emit({ ...event, formPlycaRef: this.formPlycaRef, formConfig: this.formConfig });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
